import React, { Component } from 'react';
import 'katex/dist/katex.min.css';
import { BlockMath, InlineMath } from 'react-katex';
import './element-math-formula.css';

export default class ElementMathFormula extends Component {
  constructor(props) {
    super(props);

    this.state = {
      renderError: false
    };
  }

  handleChange = (content) => {
    this.props.onChange(content);
  };

  renderFormula = () => {
    const { content } = this.props;
    const { formula, display_mode = 'block' } = content;

    if (!formula || formula.trim() === '') {
      return (
        <div className="math-formula-placeholder">
          {this.props.labels && this.props.labels.elements && this.props.labels.elements.settings && this.props.labels.elements.settings.element_math_formula && this.props.labels.elements.settings.element_math_formula.content_placeholder_click_to_edit || "Clique para editar a fórmula matemática"}
        </div>
      );
    }

    try {
      const mathProps = {
        math: formula,
        renderError: (error) => (
          <div className="math-formula-error" role="alert">
            Erro na fórmula: {error.message}
          </div>
        )
      };

      const accessibleDescription = content.accessible_description || formula;
      const accessibleWrapper = (mathElement) => (
        <div 
          role="img" 
          aria-label={`${this.props.labels && this.props.labels.elements && this.props.labels.elements.settings && this.props.labels.elements.settings.element_math_formula && this.props.labels.elements.settings.element_math_formula.content_aria_label || "Fórmula matemática"}: ${accessibleDescription}`}
          title={formula}
        >
          {mathElement}
          <span className="sr-only">{accessibleDescription}</span>
        </div>
      );

      if (display_mode === 'inline') {
        return accessibleWrapper(<InlineMath {...mathProps} />);
      } else {
        return accessibleWrapper(<BlockMath {...mathProps} />);
      }
    } catch (error) {
      return (
        <div className="math-formula-error" role="alert">
          {this.props.labels && this.props.labels.elements && this.props.labels.elements.settings && this.props.labels.elements.settings.element_math_formula && this.props.labels.elements.settings.element_math_formula.content_error_message || "Erro na fórmula"}: {error.message}
        </div>
      );
    }
  };

  render() {
    const { headerActionsTemplate, footerActionsTemplate, content } = this.props;
    
    const containerStyle = {
      background: content.background_color,
      paddingTop: content.padding_top + "px",
      paddingBottom: content.padding_bottom + "px",
      color: content.formula_color,
      fontSize: content.formula_font_size
    };

    return (
      <div className={`rdp-element-math-formula-container ${this.props.className || ''}`} style={containerStyle}>
        {headerActionsTemplate}
        
        <div className="math-formula-container" role="region" aria-label={this.props.labels && this.props.labels.elements && this.props.labels.elements.settings && this.props.labels.elements.settings.element_math_formula && this.props.labels.elements.settings.element_math_formula.content_aria_region || "Conteúdo matemático"}>
          {this.renderFormula()}
        </div>

        {footerActionsTemplate}
      </div>
    );
  }
}